export default __webpack_public_path__ + "static/media/toparrow.0d5cb289.svg";